<template>
  <div style="padding: 10px">
    <el-row class="box2">
      <el-col :span="8">申请状态：{{ formData.status_name }}</el-col>
      <el-col :span="8">申请人：{{ formData.create_user_name }}</el-col>
      <el-col :span="8">申请时间：{{ formData.create_time }}</el-col>
    </el-row>

    <el-row class="box2">
      <el-col :span="8">领料总库：{{ formData.store_name }}</el-col>
      <el-col :span="16">申请备注：{{ formData.remark }}</el-col>
    </el-row>

    <el-row class="box">
      <el-col :span="3" style="text-align:left">物料编码</el-col>
      <el-col :span="5" style="text-align:left">物料名称</el-col>
      <el-col :span="2">申请数量</el-col>
      <el-col :span="3">库位</el-col>
      <el-col :span="3">批次</el-col>
      <el-col :span="2">库存数量</el-col>
      <el-col :span="2">出库数量</el-col>
      <el-col :span="2">缺料数量</el-col>
      <el-col :span="2">操作</el-col>
    </el-row>

    <div style="height:290px;overflow-y: auto;overflow-x: hidden">
      <el-row v-for="item in formData.item_list" :key="item.id" class="row" :gutter="15">
        <el-col :span="3">
          {{ item.material_code }}
        </el-col>
        <el-col :span="5">
          {{ item.material_name }}
        </el-col>
        <el-col :span="2">
          {{ item.request_cnt }}
        </el-col>
        <el-col :span="3">
          <el-input v-model="item.location_code" disabled style="width: 100%"></el-input>
        </el-col>
        <el-col :span="3">
          <el-input v-model="item.batch_no" disabled style="width: 100%"></el-input>
        </el-col>
        <el-col :span="2">
          <el-input v-model="item.cnt" disabled style="width: 100%"></el-input>
        </el-col>
        <el-col :span="2">
          <el-input-number controls-position="right" v-model="item.approval_cnt" :disabled="item.cnt < 1||item.send_type==='by_sn'" :min="0" style="width: 100%"></el-input-number>
        </el-col>
        <el-col :span="2">
          <el-input-number v-if="item.material_code" controls-position="right" v-model="item.shortage_cnt" :min="0"
                           style="width: 100%"></el-input-number>
        </el-col>
        <el-col :span="2" style="text-align: center">
          <el-button v-if="item.cnt>0" type="primary" link @click="openSnDialog(item.id)">SN明细</el-button>
        </el-col>
      </el-row>
    </div>

    <el-row style="margin-top: 15px">
      <el-col :span="24">
        <el-input type="textarea" class="quote-remark" v-model="formData.approval_remark" placeholder="审核备注" style="width: 100%" :autosize="true"></el-input>
      </el-col>
    </el-row>

    <el-form-item>
      <el-button type="primary" style="width: 150px;margin-top: 20px" @click="agreeRequest" :disabled="!['wait_approval','wait_approval_shortage'].includes(formData.status)" :loading="loading">
        发放物料
      </el-button>
      <el-button type="primary" style="width: 150px;;margin-top: 20px" @click="rejectRequest" :disabled="!['wait_approval','wait_approval_shortage'].includes(formData.status)" :loading="loading">
        否决申请
      </el-button>
    </el-form-item>


    <el-dialog v-model="showSnDialog" title="添加发放的SN" width="800" :close-on-click-modal="false">
      <el-row>
        <el-input ref="newSn" v-model="newSn" @keyup.enter="addSn" placeholder="请扫要发放的物料SN" style="width: 200px"></el-input>
        <el-button style="margin-left: 10px" @click="addSn">添加</el-button>
        <KfMessage ref="addSnMessage"/>
      </el-row>
      <el-table :data="currentItem.sn_list" :size="'large'" row-style="height: 40px" style="margin-top: 20px">
        <el-table-column property="sn" label="SN"/>
        <el-table-column label="操作" width="100">
          <template #default="scope">
            <el-button link type="primary" size="small" @click="removeSn(scope.row.sn)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ApprovalPickRequest",
  inject: ['$fn'],
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      formData: {
        request_id: '',
        create_user_name: '',
        create_time: '',
        status_name: '',
        status: '',
        item_list: [],
      },
      loading: false,
      currentItem: {},
      newSn: '',
      showSnDialog: false
    }
  },
  created() {
    this.getInfo();
  },
  methods: {
    addSn() {
      this.$refs.addSnMessage.clear()

      if (!this.newSn) {
        return this.$refs.addSnMessage.showError('SN码不能为空')
      }

      let index = this.currentItem.sn_list.findIndex(item => item.sn == this.newSn);
      if (index != -1) {
        this.$refs.newSn.select();
        return this.$refs.addSnMessage.showError('SN码已存在')
      }

      if (this.currentItem.cnt < this.currentItem.sn_list.length + 1) {
        this.$refs.newSn.select();
        return this.$refs.addSnMessage.showError('数量不能超过库存数量')
      }

      this.currentItem.sn_list.push({sn: this.newSn})

      this.calcSendType()
      this.newSn = ''
    },
    removeSn(sn) {
      let index = this.currentItem.sn_list.findIndex(item => item.sn == sn);
      if (index != -1) {
        this.currentItem.sn_list.splice(index, 1);
      }
      this.calcSendType()
    },
    calcSendType() {
      this.currentItem.approval_cnt = this.currentItem.sn_list?.length || 0

      let materialId = this.currentItem.material_id;
      let total = 0;
      let sendType = 'by_cnt';
      this.formData.item_list.forEach(item => {
        if (item.material_id == materialId) {
          total += item.approval_cnt || 0
        }
      })
      if (total > 0) {
        sendType = 'by_sn'
      }
      this.formData.item_list.forEach(item => {
        if (item.material_id == materialId) {
          item.send_type = sendType
        }
      })

    },
    openSnDialog(itemId) {
      this.newSn = ''
      this.$refs.addSnMessage?.clear()

      let item = this.formData.item_list.find(item => item.id == itemId);
      if (!item.sn_list) {
        item.sn_list = []
      }
      this.currentItem = item
      this.showSnDialog = true;

    },
    getInfo() {
      var requestId = this.parentData.id;
      this.$axios.get('wms/request/pick/getInfo?requestId=' + requestId).then(response => {
        let res = response.data
        if (res.code != 0) {
          return this.$message.error("获取明细列表失败");
        }

        this.formData = res.data;
      }, error => {
        this.$message.error(`获取失败，${error.message}`);
      })
    },
    agreeRequest() {

      var totalCnt = 0;
      let shortageCnt = 0;
      for (let i = 0; i < this.formData.item_list.length; i++) {
        let obj = this.formData.item_list[i]
        if (obj.approval_cnt > 0) {
          totalCnt += obj.approval_cnt;
        }
        if (obj.shortage_cnt > 0) {
          shortageCnt += obj.shortage_cnt;
        }
      }

      if (totalCnt == 0 && shortageCnt == 0) {
        return this.$message.error("出库数量和缺料数量的和必须大于0");
      }

      this.loading = true;
      this.$axios.post('wms/request/pick/agree', this.formData).then(response => {
        this.loading = false;
        let res = response.data
        if (res.code != 0) {
          return this.$message.error(`提交失败，${res.message}`);
        }

        this.$message.success("提交成功");
        this.getInfo()
        this.$fn.closeWindow();
        this.$fn.search();
        this.formData.status = '';
      }, error => {
        this.loading = false;
        this.$message.error(`提交失败，${error.message}`);
      })
    },
    rejectRequest() {
      this.loading = true;
      this.$axios.post('wms/request/pick/reject', this.formData).then(response => {
        this.loading = false;
        let res = response.data
        if (res.code != 0) {
          return this.$message.error(`提交失败，${res.message}`);
        }

        this.$message.success("提交成功");
        this.$fn.closeWindow();
        this.$fn.search();
        this.formData.status = '';
      }, error => {
        this.loading = false;
        this.$message.error(`提交失败，${error.message}`);
      })
    }
  }
}
</script>

<style scoped>
.form-item {
  width: 240px;
}

.product-head {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  margin-top: 15px;
}

.product-head span {
  margin-left: 50px;
}

.box {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.box2 {
  height: 35px;
  line-height: 35px;
  text-align: left;
}

.row {
  margin-top: 15px;
  padding: 0;
}

.row .tip {
  color: goldenrod;
  text-align: center;
  font-size: 14px;
}

.w-percent-90 {
  width: 90%;
}

.w100 {
  width: 120px;
}

.w95 {
  width: 95px;
}

.tax-amount {
  color: red;
  font-size: 18px;
}

.tax-amount span {
  margin-left: 15px;
}

.quote-remark {
  width: 100%;
  padding-right: 15px;
}

.close {
  position: absolute;
  top: 5px;
  right: 18px;
  font-size: 18px;
  cursor: pointer;
}
</style>